import { render } from "./Orders.vue?vue&type=template&id=1b9b0732"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"
script.render = render

export default script